import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectWorkersInfo } from "../../../selectors/selectWorkersInfo";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { ResourceRequirement } from "../resource-requirement/ResourceRequirement";
var _WorkersRequirement = function (_a) {
    var free = _a.free, total = _a.total;
    return (React.createElement("div", { className: "workers-requirement" },
        React.createElement(Icon, { icon: IdIcon.WorkersIcn, styleId: IdStyles.IconMedium }),
        React.createElement(ResourceRequirement, { required: Math.abs(total), available: free })));
};
var mapState = function (state) { return ({
    free: selectWorkersInfo(state).free,
}); };
export var WorkersRequirement = connect(mapState)(_WorkersRequirement);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/workers-requirement/WorkersRequirement.tsx
// module id = 937
// module chunks = 3